<template>
  <div class="contact-style-two pb-80">
    <div class="container">
      <div class="form-style-classic mt-200 md-mt-80">
        <form
          @submit.prevent="onSubmit($event)"
          id="contact-form"
          data-bs-toggle="validator"
        >
          <div class="row controls">
            <div
              class="col-md-6"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              <div class="input-group-meta form-group mb-60">
                <label style="font-size: 1.25rem">Vorname</label>
                <input
                  type="text"
                  name="Fname"
                  required="required"
                  data-error="Vorname ist ein Pflichtfeld!"
                />
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-6" data-aos="fade-left" data-aos-duration="1200">
              <div class="input-group-meta form-group mb-60">
                <label style="font-size: 1.25rem">Nachname</label>
                <input
                  type="text"
                  name="Lname"
                  required="required"
                  data-error="Nachname ist ein Pflichtfeld!"
                />
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-12" data-aos="fade-up" data-aos-duration="1200">
              <div class="input-group-meta form-group mb-60">
                <label style="font-size: 1.25rem">Email-Adresse</label>
                <input
                  type="email"
                  name="email"
                  required="required"
                  data-error="Email ist ein Pflichtfeld!"
                />
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-12" data-aos="fade-up" data-aos-duration="1200">
              <div class="input-group-meta form-group lg mb-40">
                <label style="font-size: 1.25rem">Deine Nachricht</label>
                <textarea
                  name="message"
                  required="required"
                  data-error="Eine Nachricht solltest du uns auch hinterlassen ..."
                ></textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-12" data-aos="fade-up" data-aos-duration="1200">
              <div
                style="display: flex; flex-direction: row; align-items: center"
              >
                <button
                  class="theme-btn-one"
                  :disabled="status === 'success'"
                  style="text-transform: uppercase"
                >
                  Senden
                </button>
                <div style="margin-left: 1rem">
                  <div v-if="status === 'error'" style="color: red">
                    {{ message }}
                  </div>
                  <div v-if="status === 'success'" style="color: green">
                    {{ message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- /.form-style-classic -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactStyle",
  data() {
    return {
      status: "",
      message: "",
    };
  },

  methods: {
    async onSubmit(event) {
      const data = {
        fname: event.target[0].value,
        lname: event.target[1].value,
        email: event.target[2].value,
        message: event.target[3].value,
      };

      const response = await fetch("/api/v1/sendmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      response
        .json()
        .then((data) => {
          this.status = data.status;
          this.message = data.message;
        })
        .catch(() => {
          this.status = "error";
          this.message =
            "Es konnte keine Verbindung zum Server hergestellt werden. Bitte versuche es später erneut.";
        });
    },
  },
};
</script>
